import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text, Textarea, useMultiStyleConfig} from '@chakra-ui/react'

const TextAreaComponent = React.forwardRef((props, ref) => {
    const {isInvalid, rules, placeholder, onBlur, ...rest} = props

    let status = undefined
    status ??= isInvalid && 'invalid'

    const styles = useMultiStyleConfig('Field', {variant: status})
    const characterCount = props.value.length
    return (
        <Box __css={styles.container}>
            <Textarea
                placeholder={`${placeholder}${rules?.required ? ' *' : ''}`}
                {...rest}
                ref={ref}
                onBlur={onBlur}
                {...styles.textArea}
                borderColor={isInvalid ? 'red.500' : 'border.secondary'}
                _hover={{
                    borderColor: isInvalid ? 'red.500' : 'border.secondary',
                }}
                sx={{
                    '&::placeholder': {
                        color: isInvalid ? 'text.danger' : 'text.secondary',
                    },
                }}
            />
            <Text {...styles.counter}>
                {characterCount}
                {'/400'}
            </Text>
        </Box>
    )
})

TextAreaComponent.displayName = 'TextAreaComponent'
TextAreaComponent.propTypes = {
    inputProps: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    isDisabled: PropTypes.bool,
    isInvalid: PropTypes.bool,
    tooltip: PropTypes.string,
    value: PropTypes.string,
    isSuccess: PropTypes.bool,
    isRequired: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    variant: PropTypes.string,
    sx: PropTypes.object,
    ariaLabel: PropTypes.string,
    rules: PropTypes.object,
}

export default TextAreaComponent
